import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { FundraiserService } from '../../../../services/fundraiser.service';
import { MediaService } from '../../../../services/media.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatButtonModule } from '@angular/material/button';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass, NgIf } from '@angular/common';

type LOCALE =
	| 'nl'
	| 'en'
	| 'es'
	| 'de'
	| 'fr'
	| 'bg'
	| 'hr'
	| 'cs'
	| 'da'
	| 'fi'
	| 'el'
	| 'hu'
	| 'it'
	| 'pl'
	| 'pt'
	| 'ro'
	| 'sk'
	| 'sv'
	| 'uk';
@Component({
    selector: 'app-edit-appeal',
    templateUrl: './edit-appeal.component.html',
    standalone: true,
    imports: [NgClass, ExtendedModule, MatButtonModule, FlexModule, MatDialogModule, MatFormFieldModule, FormsModule, ReactiveFormsModule, MatInputModule, NgIf, MatIconModule, MatProgressSpinnerModule]
})
export class EditAppealComponent implements OnInit {
	allLanguages = {
		bg: 'Bulgarian',
		hr: 'Croatian',
		cs: 'Czech',
		da: 'Danish',
		fi: 'Finnish',
		el: 'Greek',
		hu: 'Hungarian',
		it: 'Italian',
		pl: 'Polish',
		pt: 'Portuguese',
		ro: 'Romanian',
		sk: 'Slovak',
		sv: 'Swedish',
		uk: 'Ukrainian',
		nl: 'Dutch',
		de: 'Deutsch',
		es: 'Spanish',
		en: 'English',
		fr: 'French',
	};
	originalLocale: LOCALE = 'nl';
	languageIconPath: string =
		'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/';
	isSave = false;
	newAppeal: any = {};
	titleFormGroup!: UntypedFormGroup;
	quillContentCtrl: UntypedFormControl = new UntypedFormControl();
	mediaList: any;
	mediaResetControl: UntypedFormControl = new UntypedFormControl(false);
	maxLengthCheck: any;
	constructor(
		private _formBuilder: UntypedFormBuilder,
		public _mediaService: MediaService,
		public fundraiserService: FundraiserService,
		public notificationService: NotificationService,
		@Inject(MAT_DIALOG_DATA) public data: { currentFundraiser: any },
		public dialogRef: MatDialogRef<EditAppealComponent>
	) {}

	ngOnInit(): void {
		this.originalLocale = this.data?.currentFundraiser?.language_code;

		this.titleFormGroup = this._formBuilder.group({
			translationTitle: new UntypedFormControl(
				this.data?.currentFundraiser?.title,
				[
					Validators.minLength(5),
					Validators.maxLength(75),
					Validators.pattern(
						/^[\p{L}\p{N}\p{P}\p{S}\s\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FAC0}-\u{1FAFF}\u{1FB00}-\u{1FBFF}\u{1FC00}-\u{1FCFF}\u{1FD00}-\u{1FDFF}\u{1FE00}-\u{1FEFF}\u{1FF00}-\u{1FFFF}\u{2B05}\u{1F004}]*$/u
					),
				]
			),
		});
		this.titleFormGroup.markAllAsTouched();
	}
	// }
	checkBoolean(event: boolean) {
		this.maxLengthCheck = event;
	}
	discardChanges() {
		this.titleFormGroup
			.get('translationTitle')
			?.reset(this.data?.currentFundraiser?.title);
		this.mediaResetControl.setValue(true);
		this.newAppeal = {};
	}

	dialogClose() {
		try {
			this.isSave = true;
			let observableSourceList = [];
			let contentBody = this.getContentBodyObject();

			contentBody['title'] = this.titleFormGroup.get('translationTitle')?.value;
			contentBody['slug'] = this.data?.currentFundraiser?.slug;
			observableSourceList.push(
				this.fundraiserService.updateFundraiserTitle(contentBody)
			);
			forkJoin(observableSourceList).subscribe(
				(results) => {
					this.isSave = false;
					this.notificationService.openNotification(
						$localize`:@@edit_appeal_fundraiserAppeal_notification:Fundraiser Appeal is updated`,
						'',
						'success'
					);
					this.dialogRef.close(true);
				},
				(err: any) => {
					this.notificationService.openNotification(
						$localize`:@@edit_appeal_errorUpdatingFundraiser_notification:There was an error updating Fundraiser Appeal`,
						'close',
						'error'
					);
					this.isSave = false;
				}
			);
		} catch (err: any) {
			this.notificationService.openNotification(
				$localize`:@@edit_appeal_errorUpdatingFundraiser_notification:There was an error updating Fundraiser Appeal`,
				'close',
				'error'
			);
			this.isSave = false;
		}
	}

	getContentBodyObject() {
		let body: any = {};
		body['title'] = this.titleFormGroup.get('translationTitle')?.value;
		body['slug'] = this.data?.currentFundraiser?.slug;
		return body;
	}
	escapeHtml(string_with_html: any) {
		/** *.(remove any tags).(remove double space) */
		return string_with_html
			?.replace(/<[^>]*>/g, ' ')
			?.replace(/\s\s+/g, ' ')
			?.trim();
	}
	onCloseClick() {
		this.dialogRef.close();
	}
}
